import { Component, OnInit, OnDestroy, ViewChild, Output, EventEmitter, Injector, ChangeDetectorRef } from '@angular/core';
import { ComponentService } from '../../../../../../shared/abstract/component.service';
import { environment } from '../../../../../../environments/environment';
import { MatSidenav } from '@angular/material/sidenav';
import { FormBuilder, FormControl, FormGroup, Validators, ValidationErrors, AbstractControl, ValidatorFn } from '@angular/forms';
import { RequestService } from '../../../../../../shared/services/request.service';
import { ChangePasswordModel } from '../../../../../../shared/model/change-password-model';

@Component({
  selector: 'app-user-new-password',
  templateUrl: './user-new-password.component.html',
  styleUrl: './user-new-password.component.css'
})
export class UserNewPasswordComponent extends ComponentService<any> implements OnInit {
  userInitials: any;
  userInfos: any;
  imageUrl: any;
  hidePassword = true;
  hideNewPassword = true;
  hidePasswordAgain = true;
  isLoading = false;
  passwordChangeStatus: boolean = false;
  isPasswordChanged: boolean = false;
  passwordErrorMessage: string = "";
  changePasswordModel: ChangePasswordModel = new ChangePasswordModel();
  @ViewChild('rightSidebarNewPassword') rightSidebarNewPassword!: MatSidenav;
  @Output() closeRequest = new EventEmitter<void>();

  constructor(injector: Injector, private _request: RequestService, private changeDetectorRef: ChangeDetectorRef) {
    super(injector);
  }

  resetPasswordForm = new FormGroup(
    {
      currentPassword: new FormControl('', [
        Validators.required,
        this.noWhitespaceValidator()
      ]),
      newPassword: new FormControl('', [
        Validators.required,
        this.noWhitespaceValidator(),
        Validators.minLength(8),
        Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$")
      ]),
      repeatNewPassword: new FormControl('', [
        Validators.required,
        this.noWhitespaceValidator(),
        Validators.minLength(8),
        Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$")
      ])
    },
    { validators: this.passwordMatchValidator }
  );

  passwordMatchValidator(control: AbstractControl): ValidationErrors | null {
    const form = control as FormGroup;
    const newPassword = form.get('newPassword')?.value;
    const repeatNewPassword = form.get('repeatNewPassword')?.value;

    return newPassword && repeatNewPassword && newPassword !== repeatNewPassword
      ? { passwordsDoNotMatch: true }
      : null;
  }

  override noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isWhitespace = (control.value || '').toString().trim().length === 0;
      return !isWhitespace ? null : { whitespace: true };
    };
  }

  // Şifre kuralları kontrol metodları
  hasMinLength(): boolean {
    const value = this.resetPasswordForm.get('newPassword')?.value || '';
    return value.length >= 8;
  }

  hasUppercase(): boolean {
    const value = this.resetPasswordForm.get('newPassword')?.value || '';
    return /(?=.*[A-Z])/.test(value);
  }

  hasLowercase(): boolean {
    const value = this.resetPasswordForm.get('newPassword')?.value || '';
    return /(?=.*[a-z])/.test(value);
  }

  hasNumber(): boolean {
    const value = this.resetPasswordForm.get('newPassword')?.value || '';
    return /(?=.*[0-9])/.test(value);
  }

  hasSpecialChar(): boolean {
    const value = this.resetPasswordForm.get('newPassword')?.value || '';
    return /(?=.*[#?!@$%^&*-])/.test(value);
  }

  onPasswordInput(): void {
    // Input değiştiğinde change detection'ı tetikle
    this.changeDetectorRef.detectChanges();
  }

  ngOnInit(): void {
    this.userInfos = this._appsService.userInfos;
    this.imageUrl = this.userInfos?.userImageUrl ? environment.apiUrl + '/' + this.userInfos?.userImageUrl : 'assets/icons/general/user-icon.png'

    let userName = this.userInfos?.firstName?.toUpperCase() + ' ' + this.userInfos?.lastName?.toUpperCase();
    this.getInitials(userName);

  }

  getInitials(fullName: string): void {
    if (!fullName) {
      this.userInitials = "";
    }

    const names = fullName.split(' ');
    const initials = names.map(name => name.charAt(0).toUpperCase()).join('');
    this.userInitials = initials.substring(0, 2);
  }

  close() {
    this.closeRequest.emit();
  }

  onUpdatePassword() {
    if (this.resetPasswordForm.valid) {
      const requestBody: ChangePasswordModel = {
        currentPassword: this.resetPasswordForm.value.currentPassword,
        newPassword: this.resetPasswordForm.value.newPassword
      };
      if (this.resetPasswordForm.value.currentPassword == this.resetPasswordForm.value.newPassword) {
        this.isPasswordChanged = false;
        this.passwordErrorMessage = this.languageKey("newPassError");
        return;
      }
      this.isLoading = true;
      this._request
        .changePassword(requestBody)
        .then((response) => {
          if (response.code == 1) {
            this.isPasswordChanged = true;
          }
          else {
            this.isPasswordChanged = false;
            this.passwordErrorMessage = response.message;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
        });
    } else {
      this.resetPasswordForm.markAllAsTouched();
    }
    this._appsService.logInfo("Şifre güncellendi");
  }


}
